import _ from 'underscore';

favoritesService.$inject = [
  '$rootScope',
  '$q',
  'tl.user.service',
  'loggerService',
  'utilsService'
];

const SUPPORTED_FAVORITE_TYPES = {
  EVENT: 'event',
  VENUE: 'venue'
};

export default function favoritesService($rootScope, $q, userService, loggerService, utilsService) {
  class FavoritesService {
    constructor() {
      this.favorites = null;
      this.favoritesPromise = null;

      const currentUser = userService.currentUser();

      if (currentUser) {
        this._loadFavorites(currentUser.id);
      }

      $rootScope.$on('login', () => {
        const user = userService.currentUser();

        this._loadFavorites(user.id);
      });

      $rootScope.$on('logout', () => {
        this.favorites = null;
        this.currentUser = null;
      });
    }

    get TYPES() { //eslint-disable-line
      return SUPPORTED_FAVORITE_TYPES;
    }

    toggleFavorite(type, id) {
      if (!type) return $q.reject("Type required. 'event' or 'venue'");
      if (!id) return $q.reject('No id provided unable to favorite');

      return this._requireUser()
        .then(() => {
          return this._requireFavorites();
        })
        .then(() => {
          return this.isFavorite(type, id);
        })
        .then(favorited => {
          return (favorited) ? this._unfavorite(type, id) : this._favorite(type, id);
        });
    }
    addFavorite(type, id) {
      if (!type) return $q.reject("Type required. 'event' or 'venue'");
      if (!id) return $q.reject('No id provided unable to favorite');

      return this._requireUser()
        .then(() => {
          return this._requireFavorites();
        })
        .then(() => {
          return this._favorite(type, id);
        });
    }
    removeFavorite(type, id) {
      if (!type) return $q.reject("Type required. 'event' or 'venue'");
      if (!id) return $q.reject('No id provided unable to remove');

      return this._requireUser()
        .then(() => {
          return this._requireFavorites();
        })
        .then(() => {
          return this._unfavorite(type, id);
        });
    }
    isFavorite(type, id) {
      return $q((resolve, reject) => {
        const currentUser = userService.currentUser();

        if (!currentUser) return resolve(false);

        return this._requireFavorites()
          .then(function(favs) {
            const match = _.find(favs, function(fav) {
              return (fav[type] === id);
            });

            resolve(typeof match !== 'undefined');
          })
          .catch(function(err) {
            reject(err);
          });
      });
    }
    listFavorites() { //eslint-disable-line
      const currentUser = userService.currentUser();

      if (!currentUser) {
        return $q.resolve([]);
      }

      return userService.listFavorites({
        userId: currentUser.id,
        fields: 'preferences.favorites.venue(name,seoPathname,rating,images,schedule,type,location.address),' +
          'preferences.favorites.event(name,seoPathname,description,images,date,city,venue)'
      });
    }
    _requireUser() {
      return $q((resolve, reject) => {
        let currentUser = userService.currentUser();

        if (currentUser && currentUser.id) {
          return resolve(currentUser);
        }

        const options = {
          startState: 'existingUser'
        };

        return utilsService.authUser(resp => {
          currentUser = resp.user;

          if (this.favoritesPromise === null) {
            this._loadFavorites(currentUser.id);
          }

          resolve(currentUser);
        }, err => {
          reject(err);
        }, options);
      });
    }
    _requireFavorites() {
      return $q((resolve, reject) => {
        if (this.favorites) {
          return resolve(this.favorites);
        }

        return this.favoritesPromise
          .then(response => {
            this.favorites = response;

            resolve(response);
          }, err => {
            reject(err);
          });
      });
    }
    _loadFavorites(userId) {
      this.favoritesPromise = userService.listFavorites({
        userId: userId
      });
    }
    _favorite(type, id) {
      return $q((resolve, reject) => {
        if (!id) {
          return reject('Missing id to favorite');
        }

        const currentUser = userService.currentUser();

        if (!currentUser) {
          return reject('Error. Missing user object to add favorite');
        }

        const options = {
          userId: currentUser.id
        };

        if (type === SUPPORTED_FAVORITE_TYPES.VENUE) {
          options.venueId = id;
        } else if (type === SUPPORTED_FAVORITE_TYPES.EVENT) {
          options.eventId = id;
        } else {
          return reject('Invaild type for add favorite');
        }

        return userService.favorite(options)
          .then(response => {
            this.favorites.push(response);

            $rootScope.$broadcast('favoritesChange');

            resolve(response);
          }, response => {
            reject(response);
          });
      });
    }
    _unfavorite(type, id) {
      return $q((resolve, reject) => {
        if (!id) {
          return reject('Missing id to favorite');
        }

        const currentUser = userService.currentUser();

        if (!currentUser) {
          return reject('Error. Missing user object to remove favorite');
        }

        if (type !== SUPPORTED_FAVORITE_TYPES.VENUE && type !== SUPPORTED_FAVORITE_TYPES.EVENT) {
          return reject('Invaild type for remove favorite');
        }

        const favorite = _.find(this.favorites, function(fav) {
          return (fav[type] === id);
        });

        const options = {
          userId: currentUser.id,
          favoriteId: favorite.id
        };

        return userService.unfavorite(options)
          .then(() => {
            const index = this.favorites.indexOf(favorite);
            this.favorites.splice(index, 1);

            $rootScope.$broadcast('favoritesChange');

            resolve();
          })
          .catch(reject);
      });
    }
  }

  return new FavoritesService();
}



// WEBPACK FOOTER //
// ./src/services/favoritesService.js